import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
  selector: '[mbsTextEllipsisPrepend]'
})
export class TextEllipsisPrependDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  public readonly hide = input<boolean>(false);
}
